import * as yup from 'yup';

/* contains common yup schema for reusability */

const idLength = 36;
export const idField = yup.string().max(idLength);